import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import "./AccordionComponent.css";

function AccordionComponent({ items, isbusiness }) {
  const sortedItems = Array.isArray(items)
    ? [...items].sort((a, b) => a.sortOrder - b.sortOrder)
    : [];

  // State to track which accordion tab is open
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <Accordion
      activeIndex={activeIndex}
      onTabChange={(e) => setActiveIndex(e.index)} // Update active index on click
    >
      {sortedItems.length > 0 ? (
        sortedItems.map((item, index) => (
          <AccordionTab
            key={index}
            header={
              <div
                className={`accordion-header ${
                  isbusiness ? "business-header" : ""
                }`}
              >
                <p className="accordion-index">
                  {String(index + 1).padStart(2, "0")}
                </p>
                <h2 className="accordion-title">{item.title}</h2>
              </div>
            }
          >
            <div className="accordion-content">
              {item.description && (
                <div
                  className="business-accordion-desc"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></div>
              )}

              {item.description1 && (
                <div
                  className="first-accordion-desc"
                  dangerouslySetInnerHTML={{ __html: item.description1 }}
                ></div>
              )}

              {item.title2 && (
                <p className="second-accordion-title">{item.title2}</p>
              )}

              {item.description2 && (
                <div
                  className="second-accordion-desc"
                  dangerouslySetInnerHTML={{ __html: item.description2 }}
                ></div>
              )}
            </div>
          </AccordionTab>
        ))
      ) : (
        <p>No items available</p>
      )}
    </Accordion>
  );
}

export default AccordionComponent;
